<template>
  <div>
    <b-container>
      <b-form @submit.prevent="onSubmit">
        <validation-observer ref="accountRules" tag="form">
          <div v-for="(item, index) in form" :key="index">
            <b-row v-if="item.tipe == 'select'" class="mb-1">
              <b-col md="6">
                <b-form-group :label-for="item.pertanyaan">
                  <label v-html="formatLabel(item.pertanyaan, item.is_required)"></label>
                  <label style="color:darkgray">{{ item.keterangan }}</label>
                  <validation-provider #default="{ errors }" :name="item.pertanyaan" :rules="item.is_required ? 'required' : ''">
                    <v-select
                      :id="item.uuid"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :reduce="val => val.value"
                      v-model="item.jawaban_angket.jawaban"
                      :options="item.pilihanOption.options"
                      placeholder="Pilih Jawaban"
                      @input="(val) => updateJawaban(item.jawaban_angket.jawaban, item.jawaban_angket.uuid, item.tipe, item.list)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-else-if="item.tipe == 'text'" class="mb-1">
              <b-col md="6">
                <b-form-group :label-for="item.pertanyaan">
                  <label v-html="formatLabel(item.pertanyaan, item.is_required)"></label>
                  <label style="color:darkgray">{{ item.keterangan }}</label>
                  <validation-provider #default="{ errors }" :name="item.pertanyaan" :rules="item.is_required ? 'required' : ''">
                  <b-form-textarea
                    :id="item.uuid"
                    v-model="item.jawaban_angket.jawaban"
                    @input="(val) => updateJawaban(item.jawaban_angket.jawaban, item.jawaban_angket.uuid, item.tipe, item.list)"
                    rows="3"
                    required
                  ></b-form-textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-else-if="item.tipe == 'checkbox'" class="mb-1">
              <b-col md="12">
                <b-form-group :label-for="item.pertanyaan">
                  <label v-html="formatLabel(item.pertanyaan, item.is_required)"></label><br>
                  <label style="color:darkgray">{{ item.keterangan }}</label>
                  <validation-provider #default="{ errors }" :name="item.pertanyaan" :rules="item.is_required ? 'required' : ''">
                  <b-form-checkbox-group
                    v-model="item.jawaban_angket.jawaban"
                    :options="item.pilihanOption"
                    @input="(val) => updateJawaban(item.jawaban_angket.jawaban, item.jawaban_angket.uuid, item.tipe, item.list)"
                  ></b-form-checkbox-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-else-if="item.tipe == 'number'" class="mb-1">
              <b-col md="6">
                <b-form-group :label-for="item.pertanyaan">
                  <label v-html="formatLabel(item.pertanyaan, item.is_required)"></label><br>
                  <label style="color:darkgray">{{ item.keterangan }}</label>
                  <validation-provider #default="{ errors }" :name="item.pertanyaan" :rules="item.is_required ? 'required' : ''">
                  <b-form-input
                    :id="item.uuid"
                    v-model="item.jawaban_angket.jawaban"
                    :type="'number'"
                    required
                    @input="(val) => updateJawaban(item.jawaban_angket.jawaban, item.jawaban_angket.uuid, item.tipe, item.list)"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-else-if="item.tipe == 'radio' || item.tipe == 'scoring'" class="mb-1">
              <b-col md="12">
                <b-form-group :label-for="item.pertanyaan">
                  <label v-html="formatLabel(item.pertanyaan, item.is_required)"></label><br>
                  <label style="color:darkgray">{{ item.keterangan }}</label>
                  <validation-provider #default="{ errors }" :name="item.pertanyaan" :rules="item.is_required ? 'required' : ''">
                  <b-form-radio-group
                    v-model="item.jawaban_angket.jawaban"
                    :options="item.pilihanOption"
                    required
                    @input="(val) => updateJawaban(item.jawaban_angket.jawaban, item.jawaban_angket.uuid, item.tipe, item.list)"
                  ></b-form-radio-group>
                </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
        <b-row>
          <b-col cols="6" class="text-right mt-2">
            <b-button type="submit" variant="primary">Simpan</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import {
  BContainer,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BRow,
  BCol,
  BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { getAngket, updateAngket } from '@/connection-api/angket'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BContainer,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BRow,
    BCol,
    BButton,
    vSelect
  },
  data() {
    return {
      form: [],
      ratings: [
        { text: 'Sangat Baik', value: 'Sangat Baik' },
        { text: 'Baik', value: 'Baik' },
        { text: 'Cukup', value: 'Cukup' },
        { text: 'Kurang', value: 'Kurang' },
        { text: 'Sangat Kurang', value: 'Sangat Kurang' }
      ],
      facilities: [
        { text: 'Perpustakaan', value: 'Perpustakaan' },
        { text: 'Lab Komputer', value: 'Lab Komputer' },
        { text: 'Ruang Kelas', value: 'Ruang Kelas' },
        { text: 'Wifi', value: 'Wifi' }
      ],
      departments: [
        { text: 'Teknik Informatika', value: 'Teknik Informatika' },
        { text: 'Sistem Informasi', value: 'Sistem Informasi' },
        { text: 'Teknik Komputer', value: 'Teknik Komputer' },
        { text: 'Ilmu Komputer', value: 'Ilmu Komputer' }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    onSubmit() {
      this.$refs.accountRules.validate().then(success => {
          if (success) {
            alert('Data Berhasil Disimpan')
          } else {
            alert('Lengkapi data yang wajib diisi')
          }
        })
    },
    formatLabel(pertanyaan, isRequired) {
      return isRequired == 'ya' ? `${pertanyaan} <span class="text-danger">*</span>` : pertanyaan
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          label: element.nama,
          value: element.uuid
        })
      })
    },
    buildOptionCheckbox(data, option) {
      data.forEach(element => {
        option.push({
          text: element.nama,
          value: element.uuid
        })
      })
    },
    updateJawaban(jawaban, uuid, tipe, list) {
      var data = {
        jawaban: jawaban,
        uuid: uuid,
        tipe: tipe,
        list: list
      }

      updateAngket(data)
        .then(response => {})
        .catch(error => {})
    },
    loadData() {
      getAngket(this.$route.params.uuid)
        .then(response => {
          if (response.data.success) {
            this.form = response.data.data || []
            this.form.forEach(element => {
              switch (element.tipe) {
                case 'select':
                  element.pilihanOption = {
                    selected: 'id',
                    options: [{ value: null, label: '--Pilih Jawaban --' }]
                  }
                  this.buildOption(element.pilihan, element.pilihanOption)
                  break
                case 'checkbox':
                  if (element.jawaban_angket.jawaban == null) {
                    element.jawaban_angket.jawaban = []
                  }

                  element.pilihanOption = []
                  this.buildOptionCheckbox(element.pilihan, element.pilihanOption)
                  break
                case 'radio':
                  element.pilihanOption = []
                  this.buildOptionCheckbox(element.pilihan, element.pilihanOption)
                  break
                case 'scoring':
                  element.pilihanOption = []
                  this.buildOptionCheckbox(element.pilihan, element.pilihanOption)
                  break
                default:
                  break
              }
            })
          }
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    }
  }
}
</script>
